export default {
    getLastWaitlistEntry(state) {
        return state.lastWaitlistEntry;
    },
};
